/* eslint-disable */
import _m0 from "protobufjs/minimal";

export const protobufPackage = "surface_scan";

/**
 * This file automatically generated by skymarshal.
 * DO NOT MODIFY BY HAND!!!!
 */

export interface SpecificationSelection {
}

export enum SpecificationSelection_Enum {
  INVALID = 0,
  PILLAR = 3,
  MAP = 4,
  RADIUS = 5,
  TRANSMISSION = 6,
  TELECOM_ORBIT = 7,
  SEMANTIC_TRANSMISSION = 8,
  UNRECOGNIZED = -1,
}

export function specificationSelection_EnumFromJSON(object: any): SpecificationSelection_Enum {
  switch (object) {
    case 0:
    case "INVALID":
      return SpecificationSelection_Enum.INVALID;
    case 3:
    case "PILLAR":
      return SpecificationSelection_Enum.PILLAR;
    case 4:
    case "MAP":
      return SpecificationSelection_Enum.MAP;
    case 5:
    case "RADIUS":
      return SpecificationSelection_Enum.RADIUS;
    case 6:
    case "TRANSMISSION":
      return SpecificationSelection_Enum.TRANSMISSION;
    case 7:
    case "TELECOM_ORBIT":
      return SpecificationSelection_Enum.TELECOM_ORBIT;
    case 8:
    case "SEMANTIC_TRANSMISSION":
      return SpecificationSelection_Enum.SEMANTIC_TRANSMISSION;
    case -1:
    case "UNRECOGNIZED":
    default:
      return SpecificationSelection_Enum.UNRECOGNIZED;
  }
}

export function specificationSelection_EnumToJSON(object: SpecificationSelection_Enum): string {
  switch (object) {
    case SpecificationSelection_Enum.INVALID:
      return "INVALID";
    case SpecificationSelection_Enum.PILLAR:
      return "PILLAR";
    case SpecificationSelection_Enum.MAP:
      return "MAP";
    case SpecificationSelection_Enum.RADIUS:
      return "RADIUS";
    case SpecificationSelection_Enum.TRANSMISSION:
      return "TRANSMISSION";
    case SpecificationSelection_Enum.TELECOM_ORBIT:
      return "TELECOM_ORBIT";
    case SpecificationSelection_Enum.SEMANTIC_TRANSMISSION:
      return "SEMANTIC_TRANSMISSION";
    case SpecificationSelection_Enum.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

function createBaseSpecificationSelection(): SpecificationSelection {
  return {};
}

export const SpecificationSelection = {
  encode(_: SpecificationSelection, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SpecificationSelection {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSpecificationSelection();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): SpecificationSelection {
    return {};
  },

  toJSON(_: SpecificationSelection): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<SpecificationSelection>, I>>(base?: I): SpecificationSelection {
    return SpecificationSelection.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SpecificationSelection>, I>>(_: I): SpecificationSelection {
    const message = createBaseSpecificationSelection();
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };
